import { useDispatch, useSelector } from 'react-redux';
import { DiagnosticDropdown } from './DiagnosticDropdown';
import * as diagnosticActions from '../actions/diagnostic.actions';
import {
  currentDiagnosticSelector,
  diagnosticsCountSelector,
  diagnosticsSelector,
} from '../selectors/diagnostic.selectors';
import { DiagnosticDisplay } from './DiagnosticDisplay';
import { DiagnosticInformation } from './DiagnosticInformation';
import { trackSelectDiagnostic } from '../../analytics/thunks/trackSelectDiagnostic.thunk';
import { Text } from '@cdl/heartbeat-react';
import { SidebarSection } from '../../../shared/components/SidebarSection';

export const DiagnosticList: React.FC = () => {
  const dispatch = useDispatch();
  const diagnostic = useSelector(currentDiagnosticSelector);
  const diagnosticCount = useSelector(diagnosticsCountSelector);
  const diagnosticList = useSelector(diagnosticsSelector);

  const handleChange = (diagnosticId: number) => {
    const selectedDiagnosticIndex = diagnosticList.findIndex(
      ({ id }) => id === diagnosticId,
    );

    if (selectedDiagnosticIndex !== -1) {
      dispatch(
        trackSelectDiagnostic(diagnosticList[selectedDiagnosticIndex].expertId),
      );
      dispatch(
        diagnosticActions.setDiagnosticIndex({
          diagnosticIndex: selectedDiagnosticIndex,
        }),
      );
    }
  };

  if (diagnosticCount === 0) {
    return <></>;
  }

  return (
    <SidebarSection data-testid='diagnoses-list'>
      <Text textStyle='section-subtitle'>Saved Diagnoses</Text>
      {diagnosticCount > 0 && (
        <DiagnosticDropdown
          selected={diagnostic}
          list={diagnosticList}
          handleChange={handleChange}
        />
      )}
      {diagnostic != null && (
        <DiagnosticInformation
          updatedAt={diagnostic.updatedAt}
          pipeline={diagnostic.pipeline}
          annotationTable={diagnostic.annotationTable}
        />
      )}
      {diagnostic && <DiagnosticDisplay diagnostic={diagnostic} />}
    </SidebarSection>
  );
};
